import React from 'react';
import { Sparkles } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 px-4 sm:px-6 lg:px-8 bg-slate-950 border-t border-slate-800" data-testid="footer">
      <div className="max-w-7xl mx-auto text-center">
        <div className="flex items-center justify-center space-x-3 mb-4">
          <img src="/nexus-logo.png" alt="Nexus Creative Group LLC" className="h-14 w-14" data-testid="footer-logo-image" />
          <span className="text-xl font-bold text-white" data-testid="footer-logo-text">Nexus Creative Group LLC</span>
        </div>
        <p className="text-slate-400 mb-4" data-testid="footer-description">
          Building tomorrow's digital ventures with cutting-edge technology.
        </p>
        <p className="text-slate-500 text-sm" data-testid="footer-copyright">
          © {new Date().getFullYear()} Nexus Creative Group LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;